import { render, staticRenderFns } from "./CityWiseRegistration.vue?vue&type=template&id=6571c9c6&scoped=true&"
import script from "./CityWiseRegistration.vue?vue&type=script&lang=js&"
export * from "./CityWiseRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CityWiseRegistration.vue?vue&type=style&index=0&id=6571c9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571c9c6",
  null
  
)

export default component.exports